import { FC } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { CourseEvent } from '../../../models/CourseEvent';
import CourseEventEndpoint from '../../../../api/endpoint/CourseEventEndpoint';

interface DeleteEventModalProps {
    courseEvent: CourseEvent;
    show: boolean;
    onHide: () => void;
    initiateReload: () => void;
}



export const DeleteEventModal: FC<DeleteEventModalProps> = ({courseEvent, show, onHide, initiateReload}) => {
    const onDelete = async() => {
        const removeResult = await CourseEventEndpoint.Remove(courseEvent.course_event_id);
        if(!removeResult || removeResult.errors.length > 0) {
            console.error("Error removing course event.");
        } else {
            initiateReload();
        }
        onHide()
    };

    return(
        <Modal
            show={show}
            onHide={onHide}
            aria-labelledby="delete-event-title"
            centered
        >
            <Modal.Header>
                <Modal.Title id="delete-event-title">Delete Course Event {courseEvent.course_event_id}?</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                This action cannot be undone.
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>Cancel</Button>
                <Button variant="danger" onClick={onDelete}>Delete</Button>
            </Modal.Footer>
        </Modal>
    )
};